import React, { useEffect, useState } from 'react';
import './AddNft.css';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { axiosInstance } from '../../api';
import { endpoints } from '../../api/endpoints';
import { useNavigate } from 'react-router-dom';
import InputFile from '../../components/inputFile/InputFile';
import { useSelector } from 'react-redux';
import notify from '../../utils/notify';
import abi from '../../abi/abi.json';
import useMetaMask from '../../hooks/metamask';
import { adminWalletAddress } from '../../configs';
import Loader from '../../components/loader/Loader';
import Web3 from 'web3';

const schema = yup.object({
    nftAddress: yup.string().required('NFT contract address is required'),
    nftId: yup.string().required('NFT id is required'),
    ipfsHash: yup.string().required('NFT IPFS hash is required'),
    // nftDescription: yup.string(),
});

const AddNft = () => {
    const { connect, disconnect, isActive, account, library } = useMetaMask();
    const userLoggedIn = useSelector((state) => state.auth.userLoggedIn);
    const navigate = useNavigate();
    const [isLoading, setIsLoading] = useState(false);
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: yupResolver(schema),
    });

    useEffect(() => {
        if (!userLoggedIn) {
            navigate('/auth');
        }
    }, [userLoggedIn, navigate]);

    const submitHandler = async (submittedData) => {
        setIsLoading(true);
        const contractAddress = submittedData.nftAddress;
        const isValid = Web3.utils.isAddress(contractAddress);
        if (isValid) {
            const nftId = submittedData.nftId;
            const myContract = new library.eth.Contract(abi, contractAddress);

            const ownerAddress = await myContract.methods
                .ownerOf(nftId)
                .call()
                .then((address) => {
                    const adminAddress = adminWalletAddress;
                    if (address?.toLowerCase() !== account?.toLowerCase()) {
                        notify('You are not a owner of this NFT id!!!');
                        setIsLoading(false);
                    } else {
                        myContract.methods
                            .safeTransferFrom(account, adminAddress, nftId)
                            .send({
                                from: account,
                            })
                            .once('error', (error) => {
                                notify(error);
                            })
                            .then(async (receipt) => {
                                if (receipt) {
                                    axiosInstance
                                        .post(endpoints.depositNft, submittedData)
                                        .then((res) => {
                                            setIsLoading(false);
                                            navigate('/profile');
                                        })
                                        .catch((error) => {
                                            setIsLoading(false);
                                            notify(error.response.data.Message);
                                        });
                                }
                            })
                            .catch(() => {
                                setIsLoading(false);
                            });
                    }
                })
                .catch((err) => {
                    notify('execution reverted: ERC721: owner query for nonexistent token');
                    setIsLoading(false);
                });
        } else {
            setIsLoading(false);
            notify('Enter a valid address');
        }
    };

    return (
        <div className="add-nft">
            <h3>ADD NFT</h3>
            <div className="form-wrapper">
                <form onSubmit={handleSubmit(submitHandler)}>
                    <div className="inner-form-wrap">
                        <div className="form-block">
                            <label>NFT contract address</label>
                            <input {...register('nftAddress')} type="text" placeholder="NFT contract address" className="form-control" />
                            {errors.nftAddress && <span className="error-msg">{errors.nftAddress.message}</span>}
                        </div>
                        <div className="form-block">
                            <label>NFT ID</label>
                            <input {...register('nftId')} type="text" placeholder="NFT ID" className="form-control" />
                            {errors.nftId && <span className="error-msg">{errors.nftId.message}</span>}
                        </div>
                        <div className="form-block">
                            <label>NFT IPFS hash</label>
                            <input {...register('ipfsHash')} type="text" placeholder="NFT IPFS hash" className="form-control" />
                            {errors.ipfsHash && <span className="error-msg">{errors.ipfsHash.message}</span>}
                        </div>
                        {/* <div className="form-block">
                            <label>NFT image</label>
                            <InputFile onImageUpload={setNftImage} />
                        </div> */}
                        {/* <div className="form-block">
                            <label>NFT description</label>
                            <input {...register('nftDescription')} type="text" placeholder="NFT description" className="form-control" />
                            {errors.nftDescription && <span className="error">{errors.nftDescription.message}</span>}
                        </div> */}
                        <button type="submit" className="btn-main">
                            Add NFT
                        </button>
                    </div>
                </form>
            </div>
            {isLoading && <Loader />}
        </div>
    );
};

export default AddNft;
